
$(document).ready(function () {

    // Select first swatch in all collections 
    if (screen.width < 768) {

        const firstSwatchD = document.querySelectorAll('.item-swatches-mobile .swatch-active');

        if (firstSwatchD) {
            for (let i = 0; i < firstSwatchD.length; i++) {

                firstSwatchD[i].click();

            }
        }

    } else {

        const firstSwatchM = document.querySelectorAll('.item-swatches-desktop .swatch-active');

        if (firstSwatchM) {
            for (let i = 0; i < firstSwatchM.length; i++) {

                firstSwatchM[i].click();

            }
        }

    }


    // Add arrow on mobile carrousel 
    const swiperContainer = document.querySelectorAll('.card__media_collections .slick-slider');

    if (swiperContainer) {
        for (let i = 0; i < swiperContainer.length; i++) {

            swiperContainer[i].insertAdjacentHTML("beforeend", "<span class='right_arrow_bc'></span>");
        }
    }

    if (document.getElementById("mobile-facets__color")) {

        document.getElementById("mobile-facets__color").textContent = "Color";

    }

});
